import { Helmet } from "react-helmet"

function Kontakt() {
    return (
        <div className="flex-container full-width flex-grow-1">
          <Helmet>
              <title>Historiografija.ba | Kontakt</title>
              <meta
                  name="description"
                  content="Kontakt"
                  data-react-helmet="true" 
              />
          </Helmet>
          <div className="full-width padding-2p static-page-container">
                <h1 className="font-weight-500 text-center">Kontakt</h1>
                <p>
                  <b>Redakcija</b><br />
                  E-mail: <a href="mailto:urednik@historiografija.ba">urednik@historiografija.ba</a>.<br /><br />
                  <b>Marketing</b><br />
                  Email: <a href="mailto:marketing@historiografija.ba">marketing@historiografija.ba</a>.<br /><br />
                  <b>Adresa</b><br />
                  Udruženje za modernu historiju<br />
                  Alipašina 9, PP 154<br />
                  71000 Sarajevo<br />
                  Bosna i Hercegovina<br />
                  <a href="mailto:umhissarajevo@gmail.com">umhissarajevo@gmail.com</a><br /><br />
                </p>
          </div>
        </div>
    )
}

export default Kontakt